// extracted by mini-css-extract-plugin
export default {"container":"Home_container__MGYYT","row":"Home_row__Ylps4"};